
export default {
  name: 'Card',
  props: {
    bodyClasses: {
      type: String,
      default: '',
    },
    headerClasses: {
      type: String,
      default: '',
    },
  },
}
